import React from "react";
import { IUserStatusModel } from "../interface";
import { Box, Button, TextField } from "@mui/material";
import FormServices from "../../../Services/FormServices";
import Swal from 'sweetalert2';

type State = {
    firstName: string,
    lastName: string,
    firstNameError: string,
    lastNameError: string,
};

type Props = {
    detail: IUserStatusModel;
    accessToken: string;
    onCompleteCallback: () => void
};
class EditTaxpayer extends React.Component<Props, State> {
    row: IUserStatusModel;
    constructor(props_: Props) {
        super(props_);
        this.row = props_.detail;
        this.state = {
            firstName: props_.detail.firstName,
            lastName: props_.detail.lastName,
            firstNameError: '',
            lastNameError: ''
        }
    }

    async handleSubmit() {
        if (this.validateForm()) {
            Swal.fire({
                title: `Confirm Update`,
                html: `
                <div style="text-align: left;">
                    <p>Are you sure you want to update the taxpayer name?</p>  
                    <p><b>Note: </b>The existing Form 8821 will be automatically canceled. The new Form 8821 must be re-signed by the user to ensure that the updated name is reflected in the form.</p>                    
                </div>
            `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.updateTaxpayerName();
                }
            });
        }
    }

    updateTaxpayerName() {
        const requestData = {
            userId: this.row.userId,
            firstName: this.state.firstName,
            lastName: this.state.lastName
        };

        FormServices.updateTaxpayerName(requestData, this.props.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Taxpayer Name has been updated successfully.`,
                    }).then(() => {
                        // Refresh the data after successful update
                        this.props.onCompleteCallback();
                    });
                })
            }
        });
    }

    validateForm = (): boolean => {
        let isValid = true;

        // Validate first name
        if (!this.state.firstName) {
            this.setState({ firstNameError: 'First Name is required' });
            isValid = false;
        }
        else {
            this.setState({ firstNameError: '' });
        }

        // Validate last name
        if (!this.state.lastName) {
            this.setState({ lastNameError: 'Last Name is required' });
            isValid = false;
        }
        else {
            this.setState({ lastNameError: '' });
        }
        return isValid;
    };

    render() {
        return (
            <Box>
                <Box>
                    <TextField
                        label="First Name"
                        variant="outlined"
                        value={this.state.firstName}
                        fullWidth
                        error={!!this.state.firstNameError}
                        helperText={this.state.firstNameError}
                        required
                        onInput={(e: any) => {
                            this.setState({ firstName: e.target?.value });
                            this.forceUpdate();
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        mt: 2
                    }}
                >
                    <TextField
                        label="Last Name"
                        variant="outlined"
                        value={this.state.lastName}
                        fullWidth
                        error={!!this.state.lastNameError}
                        helperText={this.state.lastNameError}
                        required
                        onInput={(e: any) => {
                            this.setState({ lastName: e.target?.value });
                            this.forceUpdate();
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        mt: 2
                    }}>
                    <TextField
                        label="Email"
                        variant="outlined"
                        value={this.row.email}
                        fullWidth
                        disabled
                        sx={{
                            "& .MuiInputLabel-root.Mui-disabled": {
                                color: "#666 !important",
                            },
                        }}
                    />
                </Box>
                <Box
                    component="form" noValidate autoComplete="off"
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 2,
                        mt: 4,
                    }}>
                    <Button
                        variant="contained"
                        onClick={() => this.handleSubmit()}
                        size="medium"
                        sx={{
                            margin: 'auto',
                            textTransform: 'none',
                            backgroundColor: 'var(--secondary-main)',
                            color: 'var(--primary-main)',
                        }}
                    > Submit </Button>
                </Box>
            </Box>
        )
    }
}

export default EditTaxpayer;